import React, { useContext, useEffect, useState } from 'react';
import { Breadcrumb } from "@boozallen-uip/uswds-react-core";
import { SectionContainer, SectionHeader, SectionSubHeader } from "../shared.styled";
import PageHeader from '../../components/PageHeader/PageHeader.component';
import WelcomeResources from './WelcomeResouces.component';
import useAccount from '../../hooks/useAccount.hook';
import { UserContext } from '../UserContext';
import UserRequestStatus from '../../components/UserRequestStatus.component';
import useEntity from '../../hooks/useEntity.hook';
import usePrimaryPoc from '../../hooks/usePrimaryPoc.hook';
import { BASE_TITLE, HOME_URL, WELCOME_URL } from '../../utlities/core.constants';
import { getDenialReasonDisplayText } from '../Account/denialReasonOptions';

export default function Welcome(){
  const [request, setRequest] = useState(null);
  const [entity, setEntity] = useState(null);
  const [primaryPoc, setPrimaryPoc] = useState(null);
  const {getUserAccessRequest} = useAccount();
  const { user, userEntity } = useContext(UserContext);
  const { getVendors, getAgency } = useEntity();
  const { getPrimaryPoc } = usePrimaryPoc();

  useEffect(() => {
    document.title = `${BASE_TITLE} - Account Home`;
  }, []);

  useEffect(() => {
    if(!entity){
      return;
    }

    if(!entity.primaryPocId){
      setPrimaryPoc({});
    }

    (async() => {
      const response = await getPrimaryPoc(entity.primaryPocId);
      setPrimaryPoc(response);
    })();
  }, [entity])

  useEffect(() => {
    if(!user){
      return;
    }

    (async() => {
      const response = await getUserAccessRequest();

      if(response.vendorId){
        const vendors = await getVendors();
        const entityResponse = vendors.find(v => v.id === response.vendorId);
        if(entityResponse) setEntity(entityResponse);
      }
      if(response.agencyId) {
        const entityResponse = await getAgency(response.agencyId);
        setEntity(entityResponse);
      }
      setRequest(response);
    })();
  }, [user])

  if(!request) {
    return null;
  }

  return (
    <>
    <PageHeader imageUrl="/page-banners/account_hero_2x.webp" backgroundSize='2800px 391px' className='2xl:!bg-cover'>
      Account Home
    </PageHeader>
    <SectionContainer>
      <Breadcrumb links={[{"href": HOME_URL, "text": "Home"}, {"href": WELCOME_URL, "text": "Account Home"}]} />
      {request && entity ? <UserRequestStatus request={request} entity={entity} primaryPoc={primaryPoc} /> : null}
      <SectionHeader>Welcome to Your ACR Repository Account</SectionHeader>
      <section>
        {
          !request.decisionDate ?
          (<p>Your request is awaiting approval with your organization’s POC. The details of your request are below:</p>) :
          null
        }
        {
          request.decisionDate && !!request.isApproved === false ?
          (<p>Your request has been denied by your organization’s POC. The details of your request are below:</p>) :
          null
        }
        {
          request.decisionDate && request.isApproved === true ?
          (<p>Your request has been approved by your organization’s POC. The details of your request are below:</p>) :
          null
        }
        <div className='mb-4 [&>div]:mb-1'>
          <div><span className='font-bold'>Name: </span>{request.name}</div>
          <div><span className='font-bold'>Account status: </span>{user?.status}</div>
          <div><span className='font-bold'>Email: </span>{request.userName}</div>
          <div><span className='font-bold'>Organization: </span>{entity?.name || userEntity?.entity?.name}</div>
          <div><span className='font-bold'>Additional comments: </span>{request.additionalComments}</div>
          {request.decisionDate && request.isApproved === false && request.denialReason ? (
            <div><span className='font-bold'>Denial reason: </span>{getDenialReasonDisplayText(request.denialReason)}</div>
          ) : null}
        </div>
        <p className='mb-8'>
        If you need help or have any questions, please reach out to {entity?.name || userEntity?.entity?.name} - ({primaryPoc?.email || userEntity?.primaryPoc?.email}).
        </p>
      </section>
      <section>
        <SectionSubHeader>Browse these resources to get started</SectionSubHeader>
        <WelcomeResources />
      </section>
    </SectionContainer>
    </>
  )
}
